import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TeacherAttendanceState } from "../types/teacherAtteandance"
// Initial state
const initialState: TeacherAttendanceState = {
    attendance: [],
    loading: false,
    error: null,
};

// Create the slice
const teacherAttendanceSlice = createSlice({
    name: 'teacherAttendance',
    initialState,
    reducers: {
        fetchTeacherAttendanceStart: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
            state.error = null;
        },
        fetchTeacherAttendanceSuccess: (state, action: PayloadAction<any>) => {
            state.attendance = action.payload.data;
            state.loading = false;
        },
        fetchTeacherAttendanceError: (state, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.loading = false;
        },
        fetchTeacherAttnSuccess: (state, action: PayloadAction<any>) => {
            state.attendance = action.payload;
            state.loading = false;
        },
        clearError: (state) => {
            state.error = null;
        },
    },
});

// Export actions
export const { fetchTeacherAttendanceStart, fetchTeacherAttendanceSuccess, fetchTeacherAttnSuccess, fetchTeacherAttendanceError, clearError } = teacherAttendanceSlice.actions;

// Export reducer
export default teacherAttendanceSlice.reducer;

